//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    REPORTS_EXPORT_HISTORY_REQUEST,
    REPORTS_EXPORT_HISTORY_REFRESH_EXPORT_LOG_URL_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import {
    reportsExportHistoryResult,
    reportsExportHistoryRefreshExportLogUrlResult,
} from 'Redux/actions';
import { clientMutation } from 'Core/data/GraphQLApi';

function* searchPmReportExportLogs({ payload }) {
    try {
        let QUERY = `
            query searchPmReportExportLogs ($dateRange: AWSDateTimeRange!, $limit: Int, $nextToken: String) {
                result: searchPmReportExportLogs (dateRange: $dateRange, limit: $limit, nextToken: $nextToken) {
                    items {
                        id
                        createdOn
                        errorMessage
                        name
                        outputURL
                        processedRecords
                        status
                        statusUpdatedOn
                        total
                        type
                    }
                    nextToken
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data) {
            yield put(reportsExportHistoryResult(data))
        }
    } catch (exc) {
        yield put(reportsExportHistoryResult())
        ExceptionManager(
            exc,
            "Modules/reports/.components/reportExportHistory/redux/saga",
            "searchPmReportExportLogs",
        )
    }
}

function* refreshExportLogUrl({ payload }) {
    try {
        const QUERY = `
            query refreshExportLogUrl($input: RefreshExportLogUrlInput!) {
                result: refreshExportLogUrl(input: $input) {
                    url
                    wasRefreshed
                    bucket
                    key
                    fileName
                }
            }
        `;

        const data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(reportsExportHistoryRefreshExportLogUrlResult({
            exportLogId: payload?.input?.exportLogId,
            result: data?.result || null,
            error: !data?.result?.url,
        }))
    } catch (exc) {
        yield put(reportsExportHistoryRefreshExportLogUrlResult({
            exportLogId: payload?.input?.exportLogId,
            result: null,
            error: true,
        }))
        ExceptionManager(
            exc,
            "Modules/reports/.components/reportExportHistory/redux/saga",
            "refreshExportLogUrl",
        )
    }
}

function* reportExportHistorySaga() {
    yield all([
        fork(watchReportsExportHistoryRequest),
        fork(watchRefreshExportLogUrlRequest),
    ]);
}

function* watchReportsExportHistoryRequest() {
    yield takeEvery(REPORTS_EXPORT_HISTORY_REQUEST, searchPmReportExportLogs);
}

function* watchRefreshExportLogUrlRequest() {
    yield takeEvery(REPORTS_EXPORT_HISTORY_REFRESH_EXPORT_LOG_URL_REQUEST, refreshExportLogUrl);
}

export default reportExportHistorySaga;
